import React, { useEffect, useState } from "react";
import { Box, Button, Container, Stack, TextField } from "@mui/material";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Privacy = () => {
	const { t } = useTranslation();

	return (
		<Container>
			<h1 style={{ fontWeight: "bold", marginTop: "80px" }}>{t("privacy.title")}</h1>
			<p>{t("privacy.p.title")}</p>

			<h2>{t("privacy.t1")}</h2>
			<p>{t("privacy.p1")}</p>

			<h2>{t("privacy.t2")}</h2>
			<p>{t("privacy.p2")}</p>

			<h2>{t("privacy.t3")}</h2>
			<p>{t("privacy.p3")}</p>

			<h2>{t("privacy.t4")}</h2>
			<p>{t("privacy.p4")}</p>

			<h2>{t("privacy.t5")}</h2>
			<p>{t("privacy.p5")}</p>

			<h2>{t("privacy.t6")}</h2>
			<p>{t("privacy.p6")}</p>

			<h2>{t("privacy.t7")}</h2>
			<p>{t("privacy.p7")}</p>


		</Container>

	)


};
